import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http } from "@/lib/api";
import { Card } from "@/components/portal/ui";

const Stat = ({ label, value, testid }) => (
  <Card className="p-5"><div className="text-xs uppercase tracking-[0.12em] text-[#8A998C]">{label}</div><div className="font-display text-3xl text-[#1A1918] mt-1" data-testid={testid}>{value}</div></Card>
);

export default function AcademicOverview() {
  const [d, setD] = useState(null);
  useEffect(() => { http.get("/admin/academics/overview").then((r) => setD(r.data)).catch(() => setD(false)); }, []);
  if (d === null) return <div className="text-[#6B665E]">Loading…</div>;
  if (!d) return <div className="text-[#6B665E]">Could not load academic overview.</div>;
  return (
    <div data-testid="academic-overview">
      <div className="eyebrow text-[#8A998C] mb-1">Infant Sleep Studies</div>
      <h1 className="font-display text-3xl text-[#1A1918] mb-6">Academic Overview</h1>
      <div className="grid sm:grid-cols-4 gap-4 mb-10">
        <Stat label="Registered students" value={d.students} testid="stat-students" />
        <Stat label="Interest registrations" value={d.interest_total} testid="stat-interest" />
        <Stat label="Cohorts" value={d.cohorts_total} testid="stat-cohorts" />
        <Stat label="Enrolled (paid) · enrollment not open" value={0} testid="stat-enrolled" />
      </div>
      <h2 className="font-display text-2xl text-[#1A1918] mb-3" id="courses">Course Management</h2>
      <Card className="p-0 overflow-x-auto" data-testid="admin-courses-table">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-[#8A998C] border-b border-[#F0ECE4]">
            {["Course", "Tuition", "Class sessions", "Readings", "Status", "Interest", "Cohorts", ""].map((h) => <th key={h} className="p-4 font-medium">{h}</th>)}
          </tr></thead>
          <tbody>
            {d.courses.map((c) => (
              <tr key={c.slug} className="border-b border-[#F0ECE4] last:border-0" data-testid={`admin-course-${c.slug}`}>
                <td className="p-4"><div className="font-medium text-[#1A1918]">{c.code} {c.title}</div><div className="text-xs text-[#8A998C]">{c.instructor.name}</div></td>
                <td className="p-4">{c.tuition}{c.tuition !== "Free" && <div className="text-xs text-[#8A998C]">per family</div>}</td>
                <td className="p-4">{c.sessions ? `${c.sessions} × 60 min` : "Self-paced"}</td>
                <td className="p-4">{c.reading_count} required · {c.optional_count} optional</td>
                <td className="p-4 text-[#6B665E]">{c.status}</td>
                <td className="p-4">{c.interest}</td>
                <td className="p-4">{c.live ? c.cohorts : "—"}</td>
                <td className="p-4 whitespace-nowrap"><a href={`/courses/${c.slug}`} target="_blank" rel="noreferrer" className="text-[#9F634E] hover:underline">Syllabus →</a></td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
      <p className="text-xs text-[#8A998C] mt-3">Future single-session workshops: {d.workshop_tuition}. Paid enrollment and tuition checkout are not active. {d.interest_undecided} interest registrations have no course selected.</p>
      <div className="flex gap-3 mt-6 text-sm">
        <Link to="/admin/cohorts" className="text-[#9F634E] hover:underline">Manage classes & cohorts →</Link>
        <Link to="/admin/leads" className="text-[#9F634E] hover:underline">View interest lists →</Link>
      </div>
    </div>
  );
}
